import Cookies from 'js-cookie';
import { profilesToLegacyAlumnoCodigos } from '../auth/jwtClaims';

export function setLegacyCompatSession(username, profileIds) {
  Cookies.set('authToken', 'true');
  Cookies.set('username', username);
  Cookies.set('alumnoCodigos', profilesToLegacyAlumnoCodigos(profileIds));
  window.dispatchEvent(new CustomEvent('authenticated'));
}

export function clearLegacyCompatSession() {
  Cookies.set('authToken', 'false');
  Cookies.set('username', '');
  Cookies.set('alumnoCodigos', '');
  window.dispatchEvent(new CustomEvent('authenticated'));
}

export function readLegacyCompatSession() {
  const authToken = Cookies.get('authToken');
  return {
    isLegacyAuthenticated: authToken === 'true' || authToken === true,
    username: Cookies.get('username') || null,
    alumnoCodigos: Cookies.get('alumnoCodigos') || ''
  };
}
